// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthService } from "../Services/AuthService";
import { useAuth } from "./AuthContext"

const ProtectedRoute = ({ children }) => {

  const { isAuthenticated} = useAuth();

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;

};

export default ProtectedRoute;
